module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/arrow--white-955c59ef3794b3570f4f7a142a2b7ae8.svg";